module.exports = __webpack_public_path__ + "static/media/value.75ba152a.svg";